import { getValue } from "../../utils/object.utils";

export const transformBlockListTableData = (blockList: Array<any>): any[] => {
  const transformDatForTable = blockList.map((block: any): any => {
    return {
      id: getValue(block, "id"),
      name: getValue(block, "name"),
      branchName: getValue(block, "school_branch.name"),
      branchId: getValue(block, "school_branch.id"),
    };
  });

  return transformDatForTable;
};
